export const headerSearchStyles = {
  root: 'relative block min-w-0 w-full',
  iconGlyph: 'h-4 w-4 shrink-0',
  iconButtonMobile:
    'hidden h-11 w-11 items-center justify-center rounded-md text-fg-secondary hover:bg-bg-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent max-[419px]:inline-flex',
  mobile:
    'fixed inset-0 z-modal flex h-dvh min-w-0 max-w-full flex-col overflow-hidden bg-bg-canvas',
  mobileHeader: 'shrink-0 border-b border-border-subtle px-3 py-3',
  scrim: 'fixed inset-0 z-overlay bg-black/40 backdrop-blur-[2px]',
  desktopPanel:
    'fixed inset-x-6 z-modal mx-auto flex w-auto max-w-[100rem] flex-col overflow-hidden rounded-xl border border-border-subtle bg-bg-canvas shadow-2xl',
} as const;
